export const API_ROUTES = {
	tenantConfig: '/v1/tenantconfig',
	appConfig: (projectId: string) => `/${projectId}/s4/s4config.json`,
	tenantAppConfig: (projectId: string, tenantId: string) =>
		`/${projectId}/s4/${tenantId}/s4config.json`,
	theme: (projectId: string, styleId: string) =>
		`/${projectId}/v2-beta/${styleId}.json`,
	exchangeToken: '/v1/exchange',
	authorized: '/v1/authorized',
	logout: '/v1/logout',
	ssoTemplates: '/v1/ssotemplates',
	ssoTemplate: (idpId: string) => `/v1/ssotemplate/${idpId}`,
	ssoConfig: '/v1/sso',
	userAttributes: '/v1/userattributes',
	roles: '/v1/roles',
	verifyDomain: (domain: string) =>
		`/v1/domainverification/verify?domain=${encodeURIComponent(domain)}`,
	dnsProviders: '/v1/domainverification/dnsproviders',
	nsServers: (domain: string) =>
		`/v1/domainverification/nsservers?domain=${encodeURIComponent(domain)}`,
	scim: {
		all: '/v1/scim',
		key: `/v1/scim/key`,
		rotateAndRevoke: '/v1/scim/rotateandrevoke',
		revoke: '/v1/scim/revoke'
	},
	ssoTest: {
		start: '/v1/ssotest/start',
		end: '/v1/ssotest/end',
		error: '/v1/ssotest/error'
	},
	fga: {
		mappable: '/v1/fga/mappable'
	},
	featureFlags: '/v1/featureflags'
};

export const MOCK_API_ROUTES = {
	appConfig: /\/([^/\n]+)\/s4\/s4config.json$/,
	tenantAppConfig: /\/([^/\n]+)\/s4\/([^/\n]+)\/s4config.json$/,
	theme: /\/([^/\n]+)\/v2-beta\/([^/\n]+).json$/,
	exchangeToken: '/v1/exchange',
	authorized: '/v1/authorized',
	logout: '/v1/logout',
	ssoTemplates: '/v1/ssotemplates',
	ssoTemplate: /\/v1\/ssotemplate\/([^/\n]+)$/,
	ssoConfig: '/v1/sso',
	userAttributes: '/v1/userattributes',
	roles: '/v1/roles',
	dnsProviders: '/v1/domainverification/dnsproviders',
	verifyDomain: /\/v1\/domainverification\/verify\?([^ ?\n]+)$/,
	nsServers: /\/v1\/domainverification\/nsservers\?([^ ?\n]+)$/,
	featureFlags: '/v1/featureflags'
};
